import cn from 'classnames'
import {motion} from 'framer-motion'
import type {RefObject} from 'react'
import {Icon} from 'src/common/Icon'
import type {SwiperClass} from 'swiper/react'

export const Navigation = ({
  swiperInstance,
  activeIndex,
  elements,
  progressBarRef,
  isDarkMode = false,
}: {
  swiperInstance: SwiperClass | null
  activeIndex: number
  elements: number
  progressBarRef: RefObject<HTMLDivElement>
  isDarkMode: boolean
}) => {
  const elementsArray = Array.from({length: elements}, (_, i) => i)

  return (
    <div className="flex items-center gap-12 max-md:mx-6 max-md:w-full max-md:justify-between md:gap-16 lg:gap-12">
      <button onClick={() => swiperInstance?.slidePrev()} className="flex items-center justify-center">
        <Icon
          name="arrow"
          className={cn('h-3 w-[13px] scale-x-flip', {
            'text-[#345142]': activeIndex === 0 && isDarkMode,
            'text-green-neon': activeIndex > 0 && isDarkMode,
            'text-moss-grey-500': !isDarkMode,
          })}
        />
      </button>
      <div className="flex gap-2">
        {elementsArray.map((_, index) => (
          <div
            key={`nav-dot-${index}`}
            className={cn('relative h-2 overflow-hidden rounded-[1px] transition-all duration-700', {
              'w-2': index !== activeIndex,
              'w-8': index === activeIndex,
              'bg-[#345142]': isDarkMode,
              'bg-moss-grey-150': !isDarkMode,
            })}
          >
            {index === activeIndex && (
              <motion.div
                ref={progressBarRef}
                className={cn('absolute z-10 size-full origin-left', {
                  'bg-green-neon': isDarkMode,
                  'bg-[#A3E038]': !isDarkMode,
                })}
              />
            )}
          </div>
        ))}
      </div>
      <button onClick={() => swiperInstance?.slideNext()} className="flex items-center justify-center">
        <Icon
          name="arrow"
          className={cn('h-3 w-[13px]', {
            'text-green-neon': activeIndex < elements - 1 && isDarkMode,
            'text-[#345142]': activeIndex === elements - 1 && isDarkMode,
            'text-moss-grey-500': !isDarkMode,
          })}
        />
      </button>
    </div>
  )
}
